import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../services/axiosInstance'
import { Link, useNavigate } from 'react-router-dom';

const LearnDropDown = ({ handleMenuClick, learnOpen, setMenuOpen }) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { i18n, t } = useTranslation();
    const language = i18n.language;
    const navigate = useNavigate();
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axiosInstance.get(
                    `/api/get-blog-categories`
                );
                if (response.data.success) {
                    setCategories(response.data.blogCategories);
                } else {
                    setError('Failed to load categories');
                }
            } catch (err) {
                console.error('Error fetching categories:', err);
                setError('An error occurred while fetching categories.');
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);
    const handleChange = (event) => {
        const selectedSlug = event;
        if (selectedSlug) {
            navigate(`/category/${selectedSlug}`);
            handleMenuClick(selectedSlug);
        }
    };
    const onBlogBtnClick = ()=> {
        navigate('/blog')
        setMenuOpen(false)
        document.body.classList.toggle("menu_open", false);
    }
    return (
        <>
            {
                learnOpen &&

                <ul>
                    {
                        categories && categories?.map((item) => {
                            return (
                                <li onClick={() => handleChange(item.slug[language])}>{item.title[language]}</li>
                            )
                        })
                    }
                    <li onClick={()=> onBlogBtnClick()}>{t("allBlogBtn")}</li>
                </ul>
            }
            {/* <select onChange={handleChange} defaultValue="">
                {
                    categories && categories?.map((item) => {
                        return (
                            <option value={item.slug[language]}>{item.title[language]}</option>
                        )
                    })
                }
            </select> */}
        </>
    )
}

export default LearnDropDown